// This file contains all relevant JS functionality for the "about-us page" - https://dpj.se/content/4-om-foretaget

export const about = {
  init: () => {
    console.debug("about.js: init");
    if ($('.about__wrapper').length) {
      document.querySelector('#about__fa-award').innerHTML =
        '<i class="fas fa-award about__circle-fas"></i>';
      document.querySelector('#about__fa-warehouse').innerHTML =
        '<i class="fas fa-warehouse about__circle-fas"></i>';
      document.querySelector('#about__fa-shopping-cart').innerHTML =
        '<i class="fas fa-shopping-cart about__circle-fas"></i>';
    }
  },
};
